<h5 *ngIf="title && !horizontal">{{ title }}</h5>
<div
  #container
  class="relative-dropdown-wrapper"
  (clickOutside)="closeWhenClickedOutside($event)"
>
  <div
    [class.horizontal]="horizontal"
    class="input-field dropdown"
    (click)="clickDropdown()"
    [class.disabled]="disabled"
    [class.readonly]="readonly"
  >
    <input
      *ngIf="!horizontal || permanentlyOpened"
      [disabled]="disabled"
      [readonly]="!searchable"
      [placeholder]="placeholder"
      [value]="inputValue"
      (input)="onType($event)"
      autocomplete="nope"
      #input
    />
    <h5 [class.horizontal]="horizontal" *ngIf="title && horizontal">
      {{ title }}
    </h5>
    <fa-icon *ngIf="showLock" class="lockIcon" [icon]="faLock"></fa-icon>
    <span *ngIf="rightText && !disabled" class="rightText">{{
      rightText
    }}</span>
    <div
      *ngIf="!permanentlyOpened && showArrow"
      [class.horizontal]="horizontal"
      [class.up-arrow]="dropdownOpen"
      [class.down-arrow]="!dropdownOpen"
    ></div>
  </div>
  <div
    [class.horizontal]="horizontal"
    [class.right]="!showDropdownOnLeft"
    [class.left]="showDropdownOnLeft"
    class="dropdown-area mpro-box"
    *ngIf="dropdownOpen"
  >
    <ng-content></ng-content>
  </div>
</div>
<p *ngIf="info && showInfo && !horizontal" class="dropdown-info-text">
  {{ info }}
</p>
